/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Pricing } from '../../../../../Components/UIElements/Pricing';

/**
 * ContractPricing Component
 *
 * @param priceData
 * @param priceAdjustmentRules
 * @returns {Element}
 * @constructor
 */
export function ContractPricing({
  priceData,
  priceAdjustmentRules,
}) {
  if (priceData.newValue) {
    return (
      <Box>
        <Pricing
          price={priceData.value}
          strikeThrough
          sx={{ marginRight: '0.75rem' }}
        />
        <Pricing
          price={priceData.newValue}
          hasAdditionalCondition={!!priceAdjustmentRules.newValue}
        />
      </Box>
    );
  }
  return (
    <Box>
      <Pricing price={priceData.value} />
    </Box>
  );
}

ContractPricing.propTypes = {
  priceData: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    newValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
  priceAdjustmentRules: PropTypes.shape({
    newValue: PropTypes.array,
  }),
};

ContractPricing.defaultProps = {
  priceData: {
    newValue: null,
  },
  priceAdjustmentRules: null,
};
